import React, { useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import { Topbar } from "./components/Navbar/Topbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Home } from "./Screens/Home";
import { Footer } from "./components/Footer/Footer";
import { WindEnergy } from "./Screens/WindEnergy";
import { MainHome } from "./Screens/MainHome";
import { WhyVtv } from "./Screens/WhyVtv";
import { Contact } from "./Screens/Contact";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top whenever pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <Topbar />
      <ScrollToTop /> {/* Add ScrollToTop component here */}
      <Routes>
          <>
          <Route
              path="/"
              element={<MainHome/>}/>

            <Route
              path="/solar-energy"
              element={<Home/>}/>
            
            <Route
              path="/investor-relations"
              element={<WindEnergy/>}/>
            <Route
              path="/Why-VTV"
              element={<WhyVtv/>}/>
            <Route
              path="/contact-us"
              element={<Contact/>}/>
          </>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
